// FETCH ALL PROPERTIES FROM MENU MASTER
export const FETCH_REQUEST_FORM_REQUEST = 'FETCH_REQUEST_FORM_REQUEST';
export const FETCH_REQUEST_FORM_SUCCESS = 'FETCH_REQUEST_FORM_SUCCESS';
export const FETCH_REQUEST_FORM_FAILURE = 'FETCH_REQUEST_FORM_FAILURE';

// CREATE PROPERTIES FOR MENU MASTER
export const CREATE_REQUEST_FORM_REQUEST = 'CREATE_REQUEST_FORM_REQUEST';
export const CREATE_REQUEST_FORM_SUCCESS = 'CREATE_REQUEST_FORM_SUCCESS';
export const CREATE_REQUEST_FORM_FAILURE = 'CREATE_REQUEST_FORM_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_REQUEST_FORM = 'CREATE_USER_FORM_REQUEST_FORM';


// UPDATE PROPERTIES FOR MENU MASTER
export const UPDATE_REQUEST_FORM_REQUEST = 'UPDATE_REQUEST_FORM_REQUEST';
export const UPDATE_REQUEST_FORM_SUCCESS = 'UPDATE_REQUEST_FORM_SUCCESS';
export const UPDATE_REQUEST_FORM_FAILURE = 'UPDATE_REQUEST_FORM_FAILURE';

// FETCH SINGLE MENU
export const FETCH_SINGLE_REQUEST_FORM_REQUEST = 'FETCH_SINGLE_REQUEST_FORM_REQUEST';
export const FETCH_SINGLE_REQUEST_FORM_SUCCESS = 'FETCH_SINGLE_REQUEST_FORM_SUCCESS';
export const FETCH_SINGLE_REQUEST_FORM_FAILURE = 'FETCH_SINGLE_REQUEST_FORM_FAILURE';

// DELETE PROPERTIES FOR MENU MASTER
export const DELETE_REQUEST_FORM_REQUEST = 'DELETE_REQUEST_FORM_REQUEST';
export const DELETE_REQUEST_FORM_SUCCESS = 'DELETE_REQUEST_FORM_SUCCESS';
export const DELETE_REQUEST_FORM_FAILURE = 'DELETE_REQUEST_FORM_FAILURE';

// USERFORM RESET

export const REQUEST_FORM_USERFORM_RESET = 'REQUEST_FORM_USERFORM_RESET';
export const RESET_CODE = 'RESET_CODE';


// FETCH MULTIPLE MENU
export const FETCH_MULTIPLE_REQUEST_FORM_REQUEST = 'FETCH_MULTIPLE_REQUEST_FORM_REQUEST';
export const FETCH_MULTIPLE_REQUEST_FORM_SUCCESS = 'FETCH_MULTIPLE_REQUEST_FORM_SUCCESS';
export const FETCH_MULTIPLE_REQUEST_FORM_FAILURE = 'FETCH_MULTIPLE_REQUEST_FORM_FAILURE';




// CLOSE PROPERTIES FOR TEAM MASTER
export const CLOSE_BTN_UPDATE_API_REQUEST = 'CLOSE_BTN_UPDATE_API_REQUEST';
export const CLOSE_BTN_UPDATE_API_SUCCESS = 'CLOSE_BTN_UPDATE_API_SUCCESS';
export const CLOSE_BTN_UPDATE_API_FAILURE = 'CLOSE_BTN_UPDATE_API_FAILURE';